'use strict';

var pixi_js = require('pixi.js');

function getView(view) {
  if (typeof view === "string") {
    return pixi_js.Sprite.from(view);
  }
  return view;
}
function getSpriteView(view) {
  if (typeof view === "string") {
    return pixi_js.Sprite.from(view);
  }
  return view;
}

exports.getSpriteView = getSpriteView;
exports.getView = getView;
//# sourceMappingURL=view.js.map
